import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Breadcrumbs, { breadcrumbLd } from "@/components/Breadcrumbs";
import Icon from "@/components/Icon";
import { Btn } from "@/components/Btn";
import { Stagger, item } from "@/components/Reveal";
import { ArrowRight } from "lucide-react";
import { TOP_SERVICES, servicePath } from "@/lib/services";
import { CTA } from "@/lib/brand";

const crumbs = [{ label: "Home", to: "/" }, { label: "Services" }];

export default function ServicesHub() {
  return (
    <>
      <Seo path="/services" title="Our Services" description="Full service junk removal in the Lowcountry, SC. Furniture, mattresses, appliances, hot tubs, cleanouts, yard debris, demolition and heavy material hauling." jsonLd={breadcrumbLd(crumbs)} />
      <PageHero eyebrow="Services" title="Everything we haul away." subtitle="From a single couch to a whole estate, our crew handles the lifting, loading and hauling.">
        <Breadcrumbs items={crumbs} />
      </PageHero>
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {TOP_SERVICES.map((s) => (
              <motion.div key={s.slug} variants={item}>
                <Link to={servicePath(s)} data-testid={`service-card-${s.slug}`}
                  className="group block h-full bg-white border-2 border-charcoal rounded-3xl p-7 shadow-brut hover:-translate-y-1 hover:shadow-brutlg transition-[transform,box-shadow] duration-200">
                  <div className="w-16 h-16 rounded-2xl border-2 border-charcoal bg-sunny flex items-center justify-center mb-5 group-hover:bg-teal group-hover:text-cream transition-colors">
                    <Icon name={s.icon} className="w-8 h-8" />
                  </div>
                  <h3 className="font-heading font-bold text-2xl flex items-center gap-2">{s.title}{s.pillar && <span className="text-xs bg-coral text-cream rounded-full px-2 py-0.5 font-body">+ more</span>}</h3>
                  <p className="mt-2 font-body text-charcoal/70">{s.blurb}</p>
                  <span className="mt-4 inline-flex items-center gap-1 font-body font-bold text-coral">Learn more <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
                </Link>
              </motion.div>
            ))}
          </Stagger>
          <div className="mt-12 text-center"><Btn to="/contact" variant="primary">{CTA.quote}</Btn></div>
        </div>
      </section>
    </>
  );
}
